import * as React from "../../_snowpack/pkg/react.js";
import AddressBlock from "./AddressBlock.js";
const SocietyEntry = ({society}) => {
  return /* @__PURE__ */ React.createElement("div", {
    className: "py-2"
  }, /* @__PURE__ */ React.createElement("span", null, society.web_url ? /* @__PURE__ */ React.createElement("a", {
    className: "underline text-blue-800",
    href: society.web_url
  }, society.full_name) : society.full_name, society.abbr_name ? ` (${society.abbr_name})` : ""), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement(AddressBlock, {
    society
  }), society.contact_email ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("a", {
    className: "underline text-blue-800",
    href: `mailto:${society.contact_email}`
  }, society.contact_email), /* @__PURE__ */ React.createElement("br", null)) : "", society.agreement_date ? `Agreement signed: ${society.agreement_date}` : "");
};
export default SocietyEntry;
